"use client";

import React from "react";
import { Tabs, Button, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate, useParams, Outlet, useLocation } from "react-router-dom";

const items = [
	{ key: "payers", label: "Payers" },
	{ key: "services", label: "Services" },
	{ key: "approve", label: "Approve" }
];

const InvoicePartnerTabs: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const location = useLocation();

	const activeKey = location.pathname.split("/").pop();

	const onTabChange = (key: string) => {
		navigate(`/admin/invoice-partner/detail/${id}/${key}`);
	};

	return (
		<>
			<div
				style={{
					background: "#fff",
					padding: "16px 24px",
					borderBottom: "1px solid #f0f0f0"
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						maxWidth: "100%",
					}}
				>
					<Tabs
						items={items}
						activeKey={activeKey}
						onChange={onTabChange}
						size="large"
					/>

					<Button
					type="default"
						icon={<Avatar icon={<UserOutlined />} size="small" style={{ backgroundColor: "#fff", color: "#1677ff" }} />}
						style={{
							borderRadius: "999px",
							padding: "0 18px",
							height: 40,
							fontWeight: 500,
							boxShadow: "0 4px 12px rgba(22, 119, 255, 0.25)",
							display: "flex",
							alignItems: "center",
							gap: 8
						}}
						onClick={() => navigate(`/admin/creator/profile/${id}`)}
					>
						Profile
					</Button>
				</div>
			</div>

			<div style={{ padding: "24px 50px" }}>
				<Outlet />
			</div>
		</>
	);
};

export default InvoicePartnerTabs;
